/**
 * Gating helpers for AI tools preloading on reader pages.
 *
 * The ai_features bootstrap data comes from the chatbot_drawer dataset
 * (serialized server-side in reader/views/web.py from the vserv features
 * endpoint). It is `{}` when the user is anonymous or the vserv fetch
 * failed. Quick Review prefetches must only run when the feature is explicitly
 * enabled; bundle loading stays optimistic for AI Chat unless it is explicitly
 * disabled so transient bootstrap failures do not hide the chat UI.
 */

export const isFeatureEnabled = (aiFeatures, key) =>
  aiFeatures?.[key]?.enabled === true

export const isFeatureExplicitlyDisabled = (aiFeatures, key) =>
  aiFeatures?.[key]?.enabled === false

/**
 * Returns the preload gates for reader AI tools:
 *  - preloadBundle: load the aitools JS bundle (needed by both aichat and
 *    Quick Review). This is intentionally permissive for aichat to preserve
 *    degraded-bootstrap recovery.
 *  - prefetchQuickReview: warm the Quick Review session/options cache
 *    (only when quick_review itself is explicitly enabled)
 */
export const getAIToolsGates = ({ aiFeatures, userid }) => {
  const quickReview = isFeatureEnabled(aiFeatures, 'quick_review')
  const aichatBundleAllowed = !isFeatureExplicitlyDisabled(aiFeatures, 'aichat')
  const hasUser = Boolean(userid)

  return {
    preloadBundle: hasUser && (quickReview || aichatBundleAllowed),
    prefetchQuickReview: hasUser && quickReview,
  }
}
